import { User } from '@ftr/contracts/api/user'
import { AuthEventType } from './auth-event-types'

export class AuthEvent {
  user?: User
  constructor(public type: AuthEventType) {}
}
